import angular from 'angular';
import ngFileUpload from '../../adapters/ng-file-upload/ng-file-upload.module';

export default angular
	.module('ui.cian.photoTransfer', [ngFileUpload])

	.factory('PhotoTransfer', ['Upload', '$http', (Upload, $http) => {
		class PhotoTransfer {
			// Используется на форме подачи
			static upload(file, url) {
				return Upload.upload({
					url,
					method: 'POST',
					headers: {
						'Content-Type': 'multipart/form-data charset=UTF-8'
					},
					data: {
						file
					}
				});
			}
			// Используется пока только в ЛК, надо нормально обобщить,
			// параметризовать http метод, сделать опциональным отбрасывание начала base64
			static uploadBase64(file, url) {
				return Upload.dataUrl(file, true).then(base64String => {
					// здесь нельзя использовать регэксп !!! НЕЛЬЗЯ
					var searchStr = 'base64,';
					var index = base64String.indexOf('base64,');
					var content = base64String.substr(index + searchStr.length);
					return $http.post(url, {content});
				});
			}
		}

		return PhotoTransfer;
	}])
	.name;
